const DEFAULT_API_BASE_URL = '/api';

export const getApiBaseUrl = () => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL || DEFAULT_API_BASE_URL;
  return baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
};

export const buildApiUrl = (path: string) => {
  const normalizedPath = path.startsWith('/') ? path.slice(1) : path;
  return `${getApiBaseUrl()}${normalizedPath}`;
};
